export default "__VITE_ASSET__BzDio19b__"